
// Inspiration: vuetify server-side v-data-table with search:
// https://codepen.io/pbastowski/pen/LmvGMz

import CustomerTemplatesQuery from "../../graphql/customer/customerTemplates.graphql"
import CreateCustomerProject from "../../graphql/customerproject/createCustomerProject.graphql"
import Dialog from "../../base_classes/Dialog"
import GroupQuery from "@/graphql/group/group.graphql"
import PriceListQuery from "@/graphql/price/priceList.graphql"
import { User } from "@coredination/common"
import * as cdn from "@coredination/components"

import { Component, Prop, Watch } from "vue-property-decorator"
import { CircularLoader } from "@coredination/components"
import { v4 as generateUuid } from "uuid"
@Component({
    apollo: {
        me: cdn.graphql.me,
        customerTemplates: {
            query: CustomerTemplatesQuery,
            result(response) {
                this.copyPropsFromTemplate()
            }
        },
        group: {
            query: GroupQuery,
            skip() {
                return !this.groupIdOrUuid
            },
            variables() {
                return { uuid: this.groupIdOrUuid }
            },
        },
        priceList: {
            query: PriceListQuery,
            result(reponse) {
                this.addPriceListToPrices()
            }
        },
    },
    components: {
        CircularLoader,
        LabelField: () => import("@/components/fields/LabelField.vue"),
        GroupField: () => import("@/components/fields/GroupField.vue"),
        FreeTextField: () => import("@/components/fields/FreeTextField.vue"),
        CustomFieldsField: () => import("@/components/fields/CustomFieldsField.vue"),
        CustomSelect: () => import("@/components/fields/CustomSelect.vue"),
        CustomAutocomplete: () => import("@/components/fields/CustomAutocomplete.vue"),
    },
})
export default class CreateCustomerProjectDialog extends Dialog {
    me?: User
    customer: any = {invoiced: true, location: {}, jobContact: {}, invoiceContact: {}, invoiceAddress: {country: 'se'}}
    customerTemplates: any
    customerProject: any = {
        invoiceContact: {},
        invoiceAddress: {},
        jobContact: {},
    }
    priceList: any[] = []
    orgNoText = this.$t('orgNumber')
    addAddressClicked = false
    group: any = {}
    errorRequiredFields: any[] = []
    saving = false
    @Prop({ default: false })
    required!: boolean
    @Prop() customerUuid!: string
    staffLedgerCheckbox: boolean = false
    showStaffLedger: boolean = false

    types= [
        { value: "BUSINESS", text: this.$t('customerType_business') },
        { value: "INDIVIDUAL", text: this.$t('customerType_individual') }
    ]


    priceListOptions = [{ value: null, text: this.$t('standard') }]

    deliveryMethods= [
        { value: "LETTER", text: this.$t('invoiceDeliveryMethod_LETTER') },
        { value: "EMAIL", text: this.$t('invoiceDeliveryMethod_EMAIL') },
        { value: "SMS", text: this.$t('invoiceDeliveryMethod_SMS') },
        { value: "EINVOICE", text: this.$t('invoiceDeliveryMethod_EINVOICE') },
        { value: "PRINTSERVICE", text: this.$t('invoiceDeliveryMethod_PRINTSERVICE') },
        { value: "CASHINVOICE", text: this.$t('invoiceDeliveryMethod_CASHINVOICE') },
        { value: "MANUAL", text: this.$t('invoiceDeliveryMethod_MANUAL') },
    ]

    refresh() {
        if (this.$apollo.queries.customerTemplates && typeof this.$apollo.queries.customerTemplates.refetch == "function")
            this.$apollo.queries.customerTemplates.refetch()
        if (this.$apollo.queries.GroupQuery && typeof this.$apollo.queries.GroupQuery.refetch == "function")
            this.$apollo.queries.GroupQuery.refetch()
    }

    mounted() {
        if (this.groupIdOrUuid) {
            if (Number.isInteger(this.groupIdOrUuid)) this.customer.groupId = this.groupIdOrUuid
            else this.customer.groupUuid = this.groupIdOrUuid
        }
    }

    get model(){
        return this.customer
    }

    getCustomerTemplate() {
        if (this.groupIdOrUuid) {
            if (Number.isInteger(this.groupIdOrUuid)) return this.customerTemplates.find((customerTemplate: any) => customerTemplate.groupId === this.groupIdOrUuid);
            else return this.customerTemplates.find((customerTemplate: any) => customerTemplate.groupUuid === this.groupIdOrUuid);
        }
        return null
    }

    copyPropsFromTemplate(){
        const template = this.getCustomerTemplate()
        if (!template) return
        for(var prop in template){
            this.customer[prop] = JSON.parse(JSON.stringify(template[prop]))
        }
        delete this.customer.uuid
        if (this.customer && this.customer.projects) {
            for (var project of this.customer.projects) {
                delete project.uuid
            }
        }
        this.customer.template = false
        if (!this.customer.location) this.customer.location = {}
        if (!this.customer.jobContact) this.customer.jobContact = {}
        if (!this.customer.invoiceContact) this.customer.invoiceContact = {}
        if (!this.customer.invoiceAddress) this.customer.invoiceAddress = {country: 'se'}
        this.setOrgNoText()
        for (var project of this.customer.projects) {
            if (project.name == '#template') {
                this.customerProject = project
                this.customerProject.name = ""
                if (!this.customerProject.location) this.customerProject.location = {}
                if (!this.customerProject.jobContact) this.customerProject.jobContact = {}
                if (!this.customerProject.invoiceContact) this.customerProject.invoiceContact = {}
                if (!this.customerProject.invoiceAddress) this.customerProject.invoiceAddress = {country: 'se'}
                this.staffLedgerCheckbox = this.customerProject.staffLedgerIdentificationNo || this.customerProject.constructorName || this.customerProject.constructorOrganizationNo
                this.showStaffLedger = this.staffLedgerCheckbox
                break
            }
        }
        this.addPriceListToPrices()
    }

    addPriceListToPrices(){
        this.priceListOptions = [{ value: null, text: this.$t('standard') }]
        if (this.priceList && this.priceList.length > 0) {
            for (var priceList of this.priceList) {
                if (this.customer.groupId && this.customer.groupId == priceList.groupId)
                    this.priceListOptions.push({ value: priceList.id, text: priceList.name })
            }
        }
    }

    // Force autofocus every time dialog is shown
    @Watch("show")
    onShow() {
        if (this.show) {
            this.$nextTick(() => {
                ;(this.$refs.name as HTMLInputElement).focus()
            })
            this.refresh()
        }
    }

    clickSave(){
        if (!this.customerProject.customerUuid) this.customerProject.customerUuid = this.customerUuid
        if (!this.customerProject.uuid) this.customerProject.uuid = generateUuid()
        /*
        if (this.model.projects) {
            for (var project of this.model.projects) {
                if (!project.uuid) project.uuid = generateUuid()
            }
        }
        */
        if (!this.verifyRequired()) {
            ;(this as any).$toast.error(this.$t("required_field_error"), { icon: 'warning' })
            return
        }
        var input = this.getInputObj()
        this.saving = true
        this.$apollo
                .mutate({
                    mutation: CreateCustomerProject,
                    variables: {
                        input
                    },
                    update(proxy, response) {
                        const hackProxy = proxy as any
                        Object.keys(hackProxy.data.data).forEach(key => {
                            if (key.match(/(customer|Customer|ROOT_QUERY)/)) hackProxy.data.delete(key)
                        })
                    },
                })
                .then(async (response) => {
                    this.saving = false
                    console.log('saved customer project', response?.data?.createCustomer)
                    this.customer = {customFields:{}}

                    this.copyPropsFromTemplate()
                    this.$emit('select', response.data.createCustomerProject)
                    this.show = false
                })
                .catch((error) => {
                    this.saving = false
                    console.error(error)
                    var errorMessage = ""
                    for (const gerror of error.graphQLErrors) {
                        errorMessage += gerror.message
                    }
                    if (errorMessage.toLowerCase().includes('kundnumret') || errorMessage.toLowerCase().includes('customer number')) 
                        this.errorRequiredFields.push('customerNo')
                    if (!errorMessage) errorMessage += this.$t('failedCreateCustomer')
                    this.$toast.error(errorMessage, { icon: 'warning' })
                })
    }

    clearErrorRequired(field: string) {
        this.errorRequiredFields = this.errorRequiredFields.filter((e) => e !== field)
    }

    verifyRequired() {
        var input: any = this.getInputObj()
        var errorRequiredFields: string[] = []
        if (!input["name"]) errorRequiredFields.push("name")
        if (this.requiredFields) {
            const requiredFields = this.requiredFields
            if (requiredFields.includes("labels"))
                if (!input["labels"] || !input["labels"].length) errorRequiredFields.push("labels")
            if (requiredFields.includes("customerProjectNo"))
                if (!input["projectNo"] && !this.autoIncrementCustomerProjectNo) errorRequiredFields.push("projectNo")
            if (requiredFields.includes("referenceNo"))
                if (!input["referenceNo"]) errorRequiredFields.push("referenceNo")
            if (requiredFields.includes("description"))
                if (!input["description"]) errorRequiredFields.push("description")

            if (requiredFields.includes("invoiceContactName"))
                if (!input["invoiceContact"] || !input.invoiceContact.name) errorRequiredFields.push("invoiceContactName")
            if (requiredFields.includes("invoiceContactEmailAddress"))
                if (!input["invoiceContact"] || !input.invoiceContact.emailAddress) errorRequiredFields.push("invoiceContactEmailAddress")
            if (requiredFields.includes("invoiceContactPhoneNo"))
                if (!input["invoiceContact"] || !input.invoiceContact.phoneNo) errorRequiredFields.push("invoiceContactPhoneNo")
            if (requiredFields.includes("invoiceAddress"))
                if (!input["invoiceAddress"] || !input.invoiceAddress.address1) errorRequiredFields.push("invoiceAddress")
            if (requiredFields.includes("invoiceAddressPostalCode"))
                if (!input["invoiceAddress"] || !input.invoiceAddress.postalCode) errorRequiredFields.push("invoiceAddressPostalCode")
            if (requiredFields.includes("invoiceAddressCity"))
                if (!input["invoiceAddress"] || !input.invoiceAddress.city) errorRequiredFields.push("invoiceAddressCity")
            //if (requiredFields.includes("invoiceAddressCountry"))
                //if (!input["invoiceAddress"] || !input.invoiceAddress.country) errorRequiredFields.push("invoiceAddressCountry")

            if (requiredFields.includes("jobContactName"))
                if (!input["jobContact"] || !input.jobContact.name) errorRequiredFields.push("jobContactName")
            if (requiredFields.includes("jobContactEmailAddress"))
                if (!input["jobContact"] || !input.jobContact.emailAddress) errorRequiredFields.push("jobContactEmailAddress")
            if (requiredFields.includes("jobContactPhoneNo"))
                if (!input["jobContact"] || !input.jobContact.phoneNo) errorRequiredFields.push("jobContactPhoneNo")

            if (requiredFields.includes("address"))
                if (!input["location"] || !input.location.placeName) errorRequiredFields.push("address")
            if (requiredFields.includes("locationDescription"))
                if (!input["locationDescription"]) errorRequiredFields.push("locationDescription")
        }
        if (this) this.errorRequiredFields = errorRequiredFields
        if (input.customFields && input.customFields.length && input.customFields.length > 0) {
            if (this.$refs && this.$refs.customFields && typeof this.$refs.customFields == "object") {
                var customFields = Object(this.$refs.customFields)
                if (!customFields.canBeSaved()) return false
            }
        }
        if (errorRequiredFields.length == 0) return true
        console.error("errorRequiredFields", errorRequiredFields)
        return false
    }

    getInputObj(){
        var copy = JSON.parse(JSON.stringify(this.customerProject));
        delete copy.__typename
        if (copy.customFields) copy.customFields.forEach((field: any) => {
            delete field.__typename
        });
        if (copy.documents) copy.documents.forEach((field: any) => {
            delete field.__typename
        });
        if (copy.termsOfPaymentDays) copy.termsOfPaymentDays = parseInt(copy.termsOfPaymentDays)
        delete copy.invoiceAddress?.__typename
        delete copy.invoiceContact?.__typename
        delete copy.jobContact?.__typename
        delete copy.location?.__typename
        delete copy.groupName
        if (!copy.projectNo) delete copy.projectNo
        if (this.customer.labels) copy.labels = this.customer.labels
        if (!this.staffLedgerCheckbox) {
            delete copy.staffLedgerIdentificationNo
            delete copy.constructorName
            delete copy.constructorOrganizationNo
        }
        return copy
    }

    get groupConfiguration(): any {
        if (!this.groupIdOrUuid || !this.group || !this.group.configuration) return false
        return JSON.parse(this.group.configuration)
    }

    get showAddress2(){
        return this.customer?.invoiceAddress?.address2 || this.addAddressClicked
    }

    get termsOfPayment(){
        if (this.customer?.termsOfPaymentText) return this.customer.termsOfPaymentText
        if (this.customer?.termsOfPaymentDays) return this.customer.termsOfPaymentDays + " " + this.$t("_days")
        return null
    }

    get requiredFields(){
        if (this.groupConfiguration) return this.groupConfiguration.customer_project_required_fields
        else return ""
    }

    get autoIncrementCustomerProjectNo(){
        return this.groupConfiguration?.auto_increment_customerprojectno && this.groupConfiguration?.auto_increment_customerprojectno == "true"
    }

    setOrgNoText() {
        this.orgNoText = this.customer?.type == "INDIVIDUAL" ? this.$t('personalNo') : this.$t('orgNumber')
    }

    hasMultipleActiveGroups() {
        return this.me && this.me.groupMemberships && this.me.groupMemberships.filter((m: any) => m.active).length > 1
    }

    get customerProjectNoPlaceholder(){
        var placeholder = this.$t('customerProjectNumber')
        if (this.autoIncrementCustomerProjectNo) placeholder += " (Auto)"
        return placeholder
    }

    get currencies() {
        if (!this.group || !this.group.currencies) return ['SEK']
        const curList = this.group.currencies.map((currency: any) => currency.code)
        return curList.length > 0 ? curList : ['SEK']
    }

    get fullscreen() {
        return this.$vuetify.breakpoint.xsOnly
    }

    get loading() {
        return this.$apollo.queries.customers.loading || this.$apollo.queries.countCustomers.loading
    }

    getCountryText(value: string) {
        let countryOption = this.countryOptions.find(option => option.value === value);
        return countryOption ? countryOption.text : value;
    }

    requiresInvoicing() {
        if (this.requiredFields) {
            const requiredFields = this.requiredFields
            return requiredFields.includes("invoiceContactName") ||
            requiredFields.includes("invoiceContactEmailAddress") ||
            requiredFields.includes("invoiceContactPhoneNo") ||
            requiredFields.includes("invoiceAddress") ||
            requiredFields.includes("invoiceAddressPostalCode") ||
            requiredFields.includes("invoiceAddressCity") ||
            requiredFields.includes("invoiceAddressCountry")
        }
        return false
    }

    toggleStaffLedger() {
        if (this.staffLedgerCheckbox) this.showStaffLedger = true
        else this.showStaffLedger = false
    }

    countryOptions= [
        { value: "af", text: "Afghanistan" },
        { value: "ax", text: "Åland Islands" },
        { value: "al", text: "Albania" },
        { value: "dz", text: "Algeria" },
        { value: "as", text: "American Samoa" },
        { value: "ad", text: "Andorra" },
        { value: "ao", text: "Angola" },
        { value: "ai", text: "Anguilla" },
        { value: "aq", text: "Antarctica" },
        { value: "ag", text: "Antigua and Barbuda" },
        { value: "ar", text: "Argentina" },
        { value: "am", text: "Armenia" },
        { value: "aw", text: "Aruba" },
        { value: "au", text: "Australia" },
        { value: "at", text: "Austria" },
        { value: "az", text: "Azerbaijan" },
        { value: "bs", text: "Bahamas" },
        { value: "bh", text: "Bahrain" },
        { value: "bd", text: "Bangladesh" },
        { value: "bb", text: "Barbados" },
        { value: "by", text: "Belarus" },
        { value: "be", text: "Belgium" },
        { value: "bz", text: "Belize" },
        { value: "bj", text: "Benin" },
        { value: "bm", text: "Bermuda" },
        { value: "bt", text: "Bhutan" },
        { value: "bo", text: "Bolivia" },
        { value: "ba", text: "Bosnia and Herzegovina" },
        { value: "bw", text: "Botswana" },
        { value: "bv", text: "Bouvet Island" },
        { value: "br", text: "Brazil" },
        { value: "io", text: "British Indian Ocean Territory" },
        { value: "bn", text: "Brunei Darussalam" },
        { value: "bg", text: "Bulgaria" },
        { value: "bf", text: "Burkina Faso" },
        { value: "bi", text: "Burundi" },
        { value: "kh", text: "Cambodia" },
        { value: "cm", text: "Cameroon" },
        { value: "ca", text: "Canada" },
        { value: "cv", text: "Cape Verde" },
        { value: "ky", text: "Cayman Islands" },
        { value: "cf", text: "Central African Republic" },
        { value: "td", text: "Chad" },
        { value: "cl", text: "Chile" },
        { value: "cn", text: "China" },
        { value: "cx", text: "Christmas Island" },
        { value: "cc", text: "Cocos (Keeling) Islands" },
        { value: "co", text: "Colombia" },
        { value: "km", text: "Comoros" },
        { value: "cg", text: "Congo" },
        { value: "cd", text: "Congo, The Democratic Republic of The" },
        { value: "ck", text: "Cook Islands" },
        { value: "cr", text: "Costa Rica" },
        { value: "ci", text: "Cote D'ivoire" },
        { value: "hr", text: "Croatia" },
        { value: "cu", text: "Cuba" },
        { value: "cy", text: "Cyprus" },
        { value: "cz", text: "Czech Republic" },
        { value: "dk", text: "Denmark" },
        { value: "dj", text: "Djibouti" },
        { value: "dm", text: "Dominica" },
        { value: "do", text: "Dominican Republic" },
        { value: "ec", text: "Ecuador" },
        { value: "eg", text: "Egypt" },
        { value: "sv", text: "El Salvador" },
        { value: "gq", text: "Equatorial Guinea" },
        { value: "er", text: "Eritrea" },
        { value: "ee", text: "Estonia" },
        { value: "et", text: "Ethiopia" },
        { value: "fk", text: "Falkland Islands (Malvinas)" },
        { value: "fo", text: "Faroe Islands" },
        { value: "fj", text: "Fiji" },
        { value: "fi", text: "Finland" },
        { value: "fr", text: "France" },
        { value: "gf", text: "French Guiana" },
        { value: "pf", text: "French Polynesia" },
        { value: "tf", text: "French Southern Territories" },
        { value: "ga", text: "Gabon" },
        { value: "gm", text: "Gambia" },
        { value: "ge", text: "Georgia" },
        { value: "de", text: "Germany" },
        { value: "gh", text: "Ghana" },
        { value: "gi", text: "Gibraltar" },
        { value: "gr", text: "Greece" },
        { value: "gl", text: "Greenland" },
        { value: "gd", text: "Grenada" },
        { value: "gp", text: "Guadeloupe" },
        { value: "gu", text: "Guam" },
        { value: "gt", text: "Guatemala" },
        { value: "gg", text: "Guernsey" },
        { value: "gn", text: "Guinea" },
        { value: "gw", text: "Guinea-bissau" },
        { value: "gy", text: "Guyana" },
        { value: "ht", text: "Haiti" },
        { value: "hm", text: "Heard Island and Mcdonald Islands" },
        { value: "va", text: "Holy See (Vatican City State)" },
        { value: "hn", text: "Honduras" },
        { value: "hk", text: "Hong Kong" },
        { value: "hu", text: "Hungary" },
        { value: "is", text: "Iceland" },
        { value: "in", text: "India" },
        { value: "id", text: "Indonesia" },
        { value: "ir", text: "Iran, Islamic Republic of" },
        { value: "iq", text: "Iraq" },
        { value: "ie", text: "Ireland" },
        { value: "im", text: "Isle of Man" },
        { value: "il", text: "Israel" },
        { value: "it", text: "Italy" },
        { value: "jm", text: "Jamaica" },
        { value: "jp", text: "Japan" },
        { value: "je", text: "Jersey" },
        { value: "jo", text: "Jordan" },
        { value: "kz", text: "Kazakhstan" },
        { value: "ke", text: "Kenya" },
        { value: "ki", text: "Kiribati" },
        { value: "kp", text: "Korea, Democratic People's Republic of" },
        { value: "kr", text: "Korea, Republic of" },
        { value: "kw", text: "Kuwait" },
        { value: "kg", text: "Kyrgyzstan" },
        { value: "la", text: "Lao People's Democratic Republic" },
        { value: "lv", text: "Latvia" },
        { value: "lb", text: "Lebanon" },
        { value: "ls", text: "Lesotho" },
        { value: "lr", text: "Liberia" },
        { value: "ly", text: "Libyan Arab Jamahiriya" },
        { value: "li", text: "Liechtenstein" },
        { value: "lt", text: "Lithuania" },
        { value: "lu", text: "Luxembourg" },
        { value: "mo", text: "Macao" },
        { value: "mk", text: "Macedonia, The Former Yugoslav Republic of" },
        { value: "mg", text: "Madagascar" },
        { value: "mw", text: "Malawi" },
        { value: "my", text: "Malaysia" },
        { value: "mv", text: "Maldives" },
        { value: "ml", text: "Mali" },
        { value: "mt", text: "Malta" },
        { value: "mh", text: "Marshall Islands" },
        { value: "mq", text: "Martinique" },
        { value: "mr", text: "Mauritania" },
        { value: "mu", text: "Mauritius" },
        { value: "yt", text: "Mayotte" },
        { value: "mx", text: "Mexico" },
        { value: "fm", text: "Micronesia, Federated States of" },
        { value: "md", text: "Moldova, Republic of" },
        { value: "mc", text: "Monaco" },
        { value: "mn", text: "Mongolia" },
        { value: "me", text: "Montenegro" },
        { value: "ms", text: "Montserrat" },
        { value: "ma", text: "Morocco" },
        { value: "mz", text: "Mozambique" },
        { value: "mm", text: "Myanmar" },
        { value: "na", text: "Namibia" },
        { value: "nr", text: "Nauru" },
        { value: "np", text: "Nepal" },
        { value: "nl", text: "Netherlands" },
        { value: "an", text: "Netherlands Antilles" },
        { value: "nc", text: "New Caledonia" },
        { value: "nz", text: "New Zealand" },
        { value: "ni", text: "Nicaragua" },
        { value: "ne", text: "Niger" },
        { value: "ng", text: "Nigeria" },
        { value: "nu", text: "Niue" },
        { value: "nf", text: "Norfolk Island" },
        { value: "mp", text: "Northern Mariana Islands" },
        { value: "no", text: "Norway" },
        { value: "om", text: "Oman" },
        { value: "pk", text: "Pakistan" },
        { value: "pw", text: "Palau" },
        { value: "ps", text: "Palestinian Territory, Occupied" },
        { value: "pa", text: "Panama" },
        { value: "pg", text: "Papua New Guinea" },
        { value: "py", text: "Paraguay" },
        { value: "pe", text: "Peru" },
        { value: "ph", text: "Philippines" },
        { value: "pn", text: "Pitcairn" },
        { value: "pl", text: "Poland" },
        { value: "pt", text: "Portugal" },
        { value: "pr", text: "Puerto Rico" },
        { value: "qa", text: "Qatar" },
        { value: "re", text: "Reunion" },
        { value: "ro", text: "Romania" },
        { value: "ru", text: "Russian Federation" },
        { value: "rw", text: "Rwanda" },
        { value: "sh", text: "Saint Helena" },
        { value: "kn", text: "Saint Kitts and Nevis" },
        { value: "lc", text: "Saint Lucia" },
        { value: "pm", text: "Saint Pierre and Miquelon" },
        { value: "vc", text: "Saint Vincent and The Grenadines" },
        { value: "ws", text: "Samoa" },
        { value: "sm", text: "San Marino" },
        { value: "st", text: "Sao Tome and Principe" },
        { value: "sa", text: "Saudi Arabia" },
        { value: "sn", text: "Senegal" },
        { value: "rs", text: "Serbia" },
        { value: "sc", text: "Seychelles" },
        { value: "sl", text: "Sierra Leone" },
        { value: "sg", text: "Singapore" },
        { value: "sk", text: "Slovakia" },
        { value: "si", text: "Slovenia" },
        { value: "sb", text: "Solomon Islands" },
        { value: "so", text: "Somalia" },
        { value: "za", text: "South Africa" },
        { value: "gs", text: "South Georgia and The South Sandwich Islands" },
        { value: "es", text: "Spain" },
        { value: "lk", text: "Sri Lanka" },
        { value: "sd", text: "Sudan" },
        { value: "sr", text: "Suriname" },
        { value: "sj", text: "Svalbard and Jan Mayen" },
        { value: "sz", text: "Swaziland" },
        { value: "se", text: this.$t('country_se') },
        { value: "ch", text: "Switzerland" },
        { value: "sy", text: "Syrian Arab Republic" },
        { value: "tw", text: "Taiwan, Province of China" },
        { value: "tj", text: "Tajikistan" },
        { value: "tz", text: "Tanzania, United Republic of" },
        { value: "th", text: "Thailand" },
        { value: "tl", text: "Timor-leste" },
        { value: "tg", text: "Togo" },
        { value: "tk", text: "Tokelau" },
        { value: "to", text: "Tonga" },
        { value: "tt", text: "Trinidad and Tobago" },
        { value: "tn", text: "Tunisia" },
        { value: "tr", text: "Turkey" },
        { value: "tm", text: "Turkmenistan" },
        { value: "tc", text: "Turks and Caicos Islands" },
        { value: "tv", text: "Tuvalu" },
        { value: "ug", text: "Uganda" },
        { value: "ua", text: "Ukraine" },
        { value: "ae", text: "United Arab Emirates" },
        { value: "gb", text: "United Kingdom" },
        { value: "us", text: "United States" },
        { value: "um", text: "United States Minor Outlying Islands" },
        { value: "uy", text: "Uruguay" },
        { value: "uz", text: "Uzbekistan" },
        { value: "vu", text: "Vanuatu" },
        { value: "ve", text: "Venezuela" },
        { value: "vn", text: "Viet Nam" },
        { value: "vg", text: "Virgin Islands, British" },
        { value: "vi", text: "Virgin Islands, U.S." },
        { value: "wf", text: "Wallis and Futuna" },
        { value: "eh", text: "Western Sahara" },
        { value: "ye", text: "Yemen" },
        { value: "zm", text: "Zambia" },
        { value: "zw", text: "Zimbabwe" }
    ]
}
